import laborCostQueryKeys from "./labor-cost.query-keys";
import basicInfoQueryKeys from "./basic-info.query-keys";
import userQueryKeys from "./user.query-keys";
import departmentQueryKeys from "./department.query-keys";
import positionQueryKeys from "./position.query-keys";
import projectQueryKeys from "./project.query-keys";
import groupQueryKeys from "./group.query-keys";
import pageResourceQueryKeys from "./page-resource.query-keys";
import inboundQueryKeys from "./inbound.query-keys";
import obtainQueryKeys from "./obtain.query-keys";
import estimateQueryKeys from "./estimate.query-keys";
import outboundQueryKeys from "./outbound.query-keys";
import purchaseQueryKeys from "./purchase.query-keys";
import orderQueryKeys from "./order.query-keys";
import stockQueryKeys from "./stock.query-keys";
import productQueryKeys from "./product.query-keys";
import notificationQueryKeys from "./notification.query-keys";
import customerCompanyQueryKeys from "./customer-company.query-keys";
import customerPersonQueryKeys from "./customer-person.query-keys";
import approvalQueryKeys from "./approval.query-keys";
import approvalDocumentQueryKeys from "./approval-document.query-keys";
import expenditureResolutionQueryKeys from "./expenditure-resolution.query-keys";
import systemConfigQueryKeys from "./system-config.query-keys";
export const queries = {
    user: userQueryKeys,
    basicInfo: basicInfoQueryKeys,
    laborCost: laborCostQueryKeys,
    department: departmentQueryKeys,
    position: positionQueryKeys,
    project: projectQueryKeys,
    group: groupQueryKeys,
    pageResource: pageResourceQueryKeys,
    inbound: inboundQueryKeys,
    outbound: outboundQueryKeys,
    obtain: obtainQueryKeys,
    estimate: estimateQueryKeys,
    purchase: purchaseQueryKeys,
    order: orderQueryKeys,
    stock: stockQueryKeys,
    product: productQueryKeys,
    notification: notificationQueryKeys,
    customerCompany: customerCompanyQueryKeys,
    customerPerson: customerPersonQueryKeys,
    approval: approvalQueryKeys,
    approvalDocument: approvalDocumentQueryKeys,
    expenditureResolution: expenditureResolutionQueryKeys,
    systemConfig: systemConfigQueryKeys,
};
